// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__le4qX","list":"BalanceDue_list__3bDky","listRow":"BalanceDue_listRow__2xpO9","total":"BalanceDue_total__27-Xk"};